import styled from 'styled-components';
import { tokens } from '../../../../../design/tokens';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const Hint = styled.span`
  color: ${tokens.color.textAsh};
  font-size: ${tokens.font.caption.size};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const Radio = styled.input`
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  accent-color: ${tokens.color.marqueeGold};
  cursor: pointer;
`;

export const Letter = styled.span`
  flex-shrink: 0;
  min-width: 22px;
  color: ${tokens.color.textMist};
  font-size: ${tokens.font.body.size};
  font-weight: 600;
`;

export const TextInput = styled.input`
  flex: 1;
  min-width: 0;
  padding: 9px 12px;
  background: ${tokens.color.fieldSlate};
  border: 1px solid transparent;
  border-radius: ${tokens.radius.sm};
  color: ${tokens.color.textWhite};
  font-size: ${tokens.font.body.size};

  &::placeholder {
    color: ${tokens.color.textAsh};
  }

  &:focus {
    outline: none;
    border-color: ${tokens.color.focusAmber};
  }
`;
export const RemoveButton = styled.button`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid ${tokens.color.errorRed};
  border-radius: ${tokens.radius.xs};
  background: transparent;
  color: ${tokens.color.errorRed};
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;

  &:hover {
    background: ${tokens.color.errorRed};
    color: #fff;
  }

  &:focus-visible {
    outline: 2px solid ${tokens.color.focusAmber};
    outline-offset: 2px;
  }
`;

export const AddButton = styled.button`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: 1px dashed ${tokens.color.marqueeGold};
  border-radius: ${tokens.radius.sm};
  background: transparent;
  color: ${tokens.color.marqueeGold};
  font-size: ${tokens.font.body.size};
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: rgba(254, 212, 74, 0.1);
  }

  &:focus-visible {
    outline: 2px solid ${tokens.color.focusAmber};
    outline-offset: 2px;
  }
`;
